import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

const SEO = ({ description, keywords, meta, title }) => {
  const lang = 'ru'
  const metaDescription = description // || site.siteMetadata.description

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: 'keywords',
          content: keywords,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    >
	  <script type="text/javascript" >{`
	     (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
		        m[i].l=1*new Date();
		        for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
		        k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
	     (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

	     ym(97841301, "init", {
		             clickmap:true,
		             trackLinks:true,
		             accurateTrackBounce:true,
		             webvisor:true
		        });
	  `}</script>
	  <noscript>{`<div><img src="https://mc.yandex.ru/watch/97841301" style="position:absolute; left:-9999px;" alt="" /></div>`}</noscript>
    </Helmet>
  )
}

SEO.defaultProps = {
  meta: [],
  description: ``,
  keywords: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  keywords: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
